import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation } from "react-query";
import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders, showMutationAlert } from "utils/helpers";

const BULK_EQUIPMENT_SURVEY_EXPORT_URL = `${BACKEND_DOMAIN}/sandbox/bulk-equipment-survey-export`;

const useDownloadBulkEquipmentSurveyCsvMutation = () => {
    const alert = useAlert();
    const accessToken = useAccessToken();

    return useMutation({
        mutationFn: async (): Promise<void> => {
            const response = await fetch(BULK_EQUIPMENT_SURVEY_EXPORT_URL, {
                headers: buildRequestHeaders(accessToken),
            });

            if (!response.ok) {
                let message = `Error ${response.status}`;
                const contentType = response.headers.get("content-type") || "";
                if (contentType.includes("application/json")) {
                    try {
                        const body = await response.json();
                        if (typeof body?.error === "string") message = body.error;
                    } catch {
                        // use default message
                    }
                }
                throw new Error(message);
            }

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            const timestamp = new Date().toISOString().slice(0, 10);
            a.download = `equipment_survey_template_${timestamp}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        },
        onError: (error) => {
            const message = error instanceof Error ? error.message : String(error);
            showMutationAlert(message, alert);
        },
    });
};

export default useDownloadBulkEquipmentSurveyCsvMutation;
